export class GradeSuggestionRequest{
    gradeSuggestionId : number;
    
    constructor(gradeSuggestionId : number)
    {
        this.gradeSuggestionId = gradeSuggestionId;
        
    }
}
